// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"292":"dc479ee2","506":"cf1b2b8f"}[chunkId] + ".css";
};